module.exports = __webpack_public_path__ + "img/gear.28e8369f.png";